import { Grid } from '@mui/material'
import StrategyNotes from './StrategyNotes'

interface StrategyNotesSectionProps {
  newNoteContent: any
  setNewNoteContent: any
  isEditMode: any
  notes: any
  setNotes: any
  handleAddNote?: any
  handleClear?: any
  isCreatingNote?: any
  setIsCreatingNote?: any
}

const StrategyNotesSection = ({ newNoteContent, setNewNoteContent, isEditMode, notes, setNotes }: StrategyNotesSectionProps) => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} pl={2.5}>
          <StrategyNotes notes={notes} setNotes={setNotes} />
        </Grid>
      </Grid>
    </>
  )
}

export default StrategyNotesSection
